import { PatientThreadAssignee, SegmentType } from "@accurx/api/ticket";
import { PatientExternalId } from "@accurx/native";
import { mapPatientSummaryExternalIdsToTicketPatientExternalIds } from "domains/concierge/internal/api/shared/mappers/patients/mapPatientSummaryExternalIdsToTicketPatientExternalIds";
import { ConciergeFetcher } from "domains/concierge/internal/types/ConciergeFetcher";

import * as TicketApiClient from "../TicketApiClient";
import { AddTicketReponse } from "../TicketApiClient";

type CreateTicketWithNoteOptions = {
    workspaceId: number;
    assignee: PatientThreadAssignee;
    patientIds: PatientExternalId[];
    note: string;
};

export const createTicketWithNote: ConciergeFetcher<
    CreateTicketWithNoteOptions,
    AddTicketReponse
> = async ({ workspaceId, patientIds, note, assignee }) => {
    const patientExternalIds =
        mapPatientSummaryExternalIdsToTicketPatientExternalIds(patientIds);

    const response = await TicketApiClient.addTicket({
        organisationId: workspaceId,
        patientId: { patientExternalIds },
        segments: { texts: [{ type: SegmentType.Text, order: 0, text: note }] },
        assignee,
    });

    return {
        updates: {
            conversations: [],
            users: [],
            teams: [],
            patients: [],
        },
        response,
    };
};
